import { Action } from 'redux';

import { RestoreContents } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../models/IContentInfo';

export interface RestoreContentAction extends Action {
  contentArray: IContentInfo[];
}

export function restoreContentsAction(contentArray: IContentInfo[]): RestoreContentAction {
  return {
    type: RestoreContents,
    contentArray: contentArray
  };
}